<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <button
        class="close-button"
        @click="$emit('skip')"
        v-if="!loading"
      >&times;</button>

      <div class="modal-body">
        <div class="upsell-content">
          <div class="wait-badge">WAIT!</div>

          <h3 class="headline">UNLOCK THE COMPLETE ACADEMY</h3>
          <p class="subheadline">You're about to get the Content Commander Challenge, but why stop there?</p>

          <div class="offer-badge">ONE-TIME OFFER</div>

          <p class="offer-description">Get access to all 9 courses, the private community, and weekly workshops for one incredible price.</p>

          <div class="course-list">
            <div class="course-list-header">All 9 Courses Included:</div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">AI Foundations Sprint</span>
              <span class="course-price free">Free Gift</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">Your AI Tools Quickstart</span>
              <span class="course-price">$129</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">AI Agents & Automation</span>
              <span class="course-price">$199</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">Code by Conversation</span>
              <span class="course-price">$99</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">Create Your Business Brain</span>
              <span class="course-price">$199</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">Command Line Bootcamp</span>
              <span class="course-price">$99</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">Content Commander Challenge</span>
              <span class="course-price">$99</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">AI Python Web Scraping</span>
              <span class="course-price">$99</span>
            </div>
            <div class="course-item">
              <i class="fas fa-check"></i>
              <span class="course-name">AI-Powered Data Enrichment</span>
              <span class="course-price">$99</span>
            </div>

            <div class="included-section">
              <div class="course-item included">
                <i class="fas fa-check"></i>
                <span class="course-name">Community Support</span>
                <span class="included-badge">Included</span>
              </div>
              <div class="course-item included">
                <i class="fas fa-check"></i>
                <span class="course-name">Weekly Workshops</span>
                <span class="included-badge">Included</span>
              </div>
              <div class="course-item included guarantee">
                <i class="fas fa-check"></i>
                <span class="course-name">7-Day Money-Back Guarantee</span>
                <span class="included-badge">Included</span>
              </div>
            </div>
          </div>

          <div class="pricing-section">
            <div class="total-value">
              <span>Total Value:</span>
              <span class="value-amount">$1,022+</span>
            </div>

            <div class="crossed-price">
              <span>Total Value: <s>$1,022+</s></span>
            </div>

            <div class="sale-price">
              <span>Your Price Today:</span>
              <span class="price-amount">${{ formattedPrice }}</span>
            </div>

            <div class="savings">You save over $770!</div>
          </div>

          <div class="button-group">
            <button class="secondary-button" @click="$emit('skip')">
              No thanks, continue with my $39 purchase
            </button>
            <button class="cta-button" @click="$emit('accept')" :disabled="loading">
              <span v-if="loading">
                <span class="spinner"></span>
                Processing...
              </span>
              <span v-else>
                YES! Unlock Full Academy
              </span>
            </button>
          </div>

          <!--
            Testimonials: migrated from Senja to Vouch (vouch.jordanurbs.com) 2026-07-26,
            same as the sales page. Baked as static markup rather than the JS widget —
            there is no Academy-specific Vouch widget, and a modal shouldn't wait on a
            third-party script to show its social proof.
            Source: GET https://vouch.jordanurbs.com/api/wall/wall-of-love
          -->
          <div class="testimonials-section">
            <div class="testimonials-header">
              <i class="fas fa-star"></i>
              What Students Are Saying
            </div>
            <figure v-for="t in testimonials" :key="t.id" class="upsell-vouch-card">
              <blockquote class="upsell-vouch-body">{{ t.body }}</blockquote>
              <figcaption class="upsell-vouch-author">
                {{ t.author }}<span v-if="t.title"> — {{ t.title }}</span>
              </figcaption>
            </figure>
          </div>

          <!-- Second CTA Button -->
          <button class="cta-button cta-bottom" @click="$emit('accept')" :disabled="loading">
            <span v-if="loading">
              <span class="spinner"></span>
              Processing...
            </span>
            <span v-else>
              <i class="fas fa-unlock"></i> YES! Unlock Full Academy
            </span>
          </button>

          <button class="secondary-button secondary-bottom" @click="$emit('skip')">
            No thanks, continue with my $39 purchase
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpsellModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Baked from vouch.jordanurbs.com/api/wall/wall-of-love on 2026-07-26.
      // Academy-level testimonials (this modal sells the Academy, not the Challenge).
      testimonials: [
        {
          id: '6a9e8223-fe69-475b-bdb1-71e504aa1ab1',
          author: 'Sarah Ceo',
          title: 'Real Estate Consultant',
          body: 'Finally! An AI course that actually helps you create a profitable business at the door. I am so grateful and excited! I highly recommend it. Totally worth your time.'
        },
        {
          id: 'a165a706-33cf-4bb2-99ed-c39a8f203a1a',
          author: 'Kenneth Gonzalez',
          title: 'Lead Analyst/Advisor',
          body: 'If you\'re considering this course, just do it. It\'s a very straightforward program that will take you from not having anything to having a solid foundation that is fun, approachable, and effective.'
        }
      ]
    };
  },
  computed: {
    price() {
      // Get price from environment variable with a fallback
      return parseInt(import.meta.env.VITE_ACADEMY_UPSELL_PRICE) || 24900;
    },
    formattedPrice() {
      // Format the price as dollars
      return (this.price / 100).toFixed(0);
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  padding: 2rem;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid #2d3a5a;
  position: relative;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  color: #888;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 2;
  transition: color 0.2s;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #FFD23F;
}

.upsell-content {
  text-align: center;
}

.wait-badge {
  display: inline-block;
  background: #ff4757;
  color: white;
  padding: 0.4rem 1.5rem;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  letter-spacing: 1px;
}

.headline {
  color: #FFD23F;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.subheadline {
  color: #b0b0b0;
  font-size: 0.95rem;
  margin-bottom: 1.25rem;
  line-height: 1.4;
}

.offer-badge {
  display: inline-block;
  background: transparent;
  color: #ff6b6b;
  padding: 0.3rem 1rem;
  border: 1px solid #ff6b6b;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: bold;
  margin-bottom: 1rem;
  letter-spacing: 1px;
}

.offer-description {
  color: #e0e0e0;
  font-size: 0.9rem;
  margin-bottom: 1.25rem;
  line-height: 1.5;
}

.course-list {
  background: #0d1117;
  border-radius: 12px;
  padding: 0.75rem;
  margin-bottom: 1.25rem;
  border: 1px solid #21262d;
}

.course-list-header {
  color: #FFD23F;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #21262d;
  margin-bottom: 0.25rem;
  text-align: left;
}

.course-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #21262d;
}

.course-item:last-child {
  border-bottom: none;
}

.course-item i {
  color: #FFD23F;
  font-size: 0.85rem;
  min-width: 20px;
}

.course-name {
  flex: 1;
  color: #e0e0e0;
  font-size: 0.85rem;
  text-align: left;
  margin-left: 0.5rem;
}

.course-price {
  color: #888;
  font-size: 0.85rem;
  min-width: 50px;
  text-align: right;
}

.course-price.free {
  color: #4ade80;
}

.included-section {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #21262d;
}

.course-item.included {
  border-bottom: 1px solid #21262d;
}

.course-item.included:last-child {
  border-bottom: none;
}

.course-item.guarantee {
  background: rgba(74, 222, 128, 0.1);
  border-radius: 6px;
  margin-top: 0.25rem;
}

.included-badge {
  color: #4ade80;
  font-size: 0.8rem;
  font-weight: 500;
}

.pricing-section {
  margin: 1.25rem 0;
  padding: 1rem;
  background: #0d1117;
  border-radius: 12px;
  border: 1px solid #21262d;
}

.total-value {
  display: none;
}

.crossed-price {
  color: #888;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}

.crossed-price s {
  color: #888;
}

.sale-price {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.sale-price span:first-child {
  color: #e0e0e0;
  font-size: 1rem;
}

.price-amount {
  color: #FFD23F;
  font-size: 2.5rem;
  font-weight: 700;
}

.savings {
  color: #4ade80;
  font-size: 0.9rem;
  font-weight: 600;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.25rem;
}

.secondary-button {
  padding: 0.75rem 1.5rem;
  background: transparent;
  color: #888;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
  order: 2;
}

.secondary-button:hover {
  color: #e0e0e0;
}

.cta-button {
  padding: 1rem 2rem;
  background: linear-gradient(45deg, #FF6B35 0%, #FFD23F 100%);
  color: #1a1a1a;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  order: 1;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 210, 63, 0.3);
}

.cta-button:disabled {
  background: #666;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(26, 26, 26, 0.3);
  border-radius: 50%;
  border-top-color: #1a1a1a;
  animation: spin 1s ease-in-out infinite;
  margin-right: 0.5rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Testimonials Section */
.testimonials-section {
  margin-top: 1.5rem;
  padding: 1rem;
  background: #0d1117;
  border-radius: 12px;
  border: 1px solid #21262d;
}

.testimonials-header {
  color: #FFD23F;
  font-weight: 600;
  font-size: 0.95rem;
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #21262d;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

/* Vouch testimonial cards (static, replaced the Senja embed 2026-07-26) */
.upsell-vouch-card {
  margin: 0 0 0.85rem;
  padding: 0.85rem 1rem;
  text-align: left;
  background: #161b22;
  border-radius: 8px;
  border-left: 3px solid #FFD23F;
}

.upsell-vouch-card:last-child {
  margin-bottom: 0;
}

.upsell-vouch-body {
  margin: 0 0 0.5rem;
  color: #e6edf3;
  font-size: 0.9rem;
  line-height: 1.5;
}

.upsell-vouch-author {
  color: #8b949e;
  font-size: 0.8rem;
  font-style: italic;
}

.testimonials-header i {
  color: #FFD23F;
}


/* Bottom CTA Button */
.cta-bottom {
  margin-top: 1.25rem;
  width: 100%;
}

.secondary-bottom {
  margin-top: 0.75rem;
  width: 100%;
  text-align: center;
}

@media (max-width: 768px) {
  .modal-content {
    padding: 1.5rem;
    max-height: 85vh;
  }

  .headline {
    font-size: 1.3rem;
  }

  .course-item {
    padding: 0.4rem 0.5rem;
  }

  .course-name {
    font-size: 0.8rem;
  }

  .course-price,
  .included-badge {
    font-size: 0.75rem;
  }

  .price-amount {
    font-size: 2rem;
  }

}
</style>
